export default function CourseTerms() {
    return (
        <>
            <section id="guitar-course-details-section">
                <div className="guitar-course-details-container">
                    <div className="guitar-course-details-content">
                        <div className="course-detail-item">
                            <h3 className="course-detail-title">TRAINING INVOLVES</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Personalized curriculum balancing two disciplines.</li>
                                <li>Cross-disciplinary learning (e.g., Singing + Instrument, Instrument + Production).</li>
                                <li>Time management and tailored repertoire.</li>
                                <li>Stage, studio, and creative integration.</li>
                            </ul>
                        </div>

                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Who is it For</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Students passionate about more than one field.</li>
                                <li>Multi-instrumentalists, singer-songwriters, and performers.</li>
                                <li>Learners aiming for flexibility and versatility.</li>
                            </ul>
                        </div>

                        <div className="course-detail-item">
                            <h3 className="course-detail-title">Learning Outcomes</h3>
                            <div className="course-detail-underline"></div>
                            <ul className="course-detail-list">
                                <li>Balanced skill development in both subjects.</li>
                                <li>Ability to compose, perform, or produce with multiple strengths.</li>
                                <li>Career advantage as a versatile musician.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 